export const CLIENT_REPORT = 'CLIENT_REPORT';
export const COACH_REPORT = 'COACH_REPORT';

export const USER_PROFILE = 'USER_PROFILE';
export const SETTINGS = 'SETTINGS';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS';
export const NOTIFICATION_SETTINGS = 'NOTIFICATION_SETTINGS';
export const SECURITY_SETTINGS = 'SECURITY_SETTINGS';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
export const SEARCH = 'SEARCH';
export const BONUSES = 'BONUSES';
export const PICKER_MODAL = 'PICKER_MODAL';

export const TESTING_OPTIONS = 'TESTING_OPTIONS';
export const RELEASE_NOTES = 'RELEASE_NOTES';

export const CLIENT_PROFILE = 'CLIENT_PROFILE';
export const COACH_PROFILE = 'COACH_PROFILE';
export const CANDIDATE_PROFILE = 'CANDIDATE_PROFILE';
export const REFERRAL_PROFILE = 'REFERRAL_PROFILE';
export const CREATE_NEW_CANDIDATE = 'CREATE_NEW_CANDIDATE';
export const SHARE_OPTAVIA_PLAN = 'SHARE_OPTAVIA_PLAN';
export const EDGE365CHALLENGESCREEN = 'EDGE365CHALLENGESCREEN';
